import { render, staticRenderFns } from "./exportData.vue?vue&type=template&id=2830f91c&scoped=true"
import script from "./exportData.vue?vue&type=script&lang=js"
export * from "./exportData.vue?vue&type=script&lang=js"
import style0 from "./exportData.vue?vue&type=style&index=0&id=2830f91c&prod&lang=scss"
import style1 from "./exportData.vue?vue&type=style&index=1&id=2830f91c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2830f91c",
  null
  
)

export default component.exports